import React, { Component } from "react";
import { connect } from "react-redux";
import { ItemListDetail } from "../components";
import { Base } from "zina-dogi-react";
import * as cpo from "../redux";

class ItemDetail extends Component {
    componentWillMount() {
        const { getItem, cpoID, itemID } = this.props;
        if (cpoID && itemID) {
            getItem(cpoID, itemID);
        }
    }

    componentWillUpdate() {}

    render() {
        const { item, loading, extraProps } = this.props;
        let cpoNumber = this.props.location.state ? this.props.location.state.cpoNumber : "";
        const { cpoItemID, cpoID } = this.props.match.params;
        const base_op = {
            className: "cpo_list",
            title: `Customer purchase order ${cpoNumber} ${cpoItemID ? `Item #${cpoItemID}` : "Add new Item"}`,
            breadcrumbs: [
                { name: "Home", rel: "/", icon: "home" },
                {
                    name: `CPO ${cpoNumber}`,
                    rel: {
                        pathname: `/detail/${cpoID}`,
                        state: { from: "importer" }
                    }
                },
                { name: `${cpoItemID ? `Item #${cpoItemID}` : "New Item"}` }
            ],
            extraProps,
            loading
        };
        return (
            <Base {...base_op}>
                <ItemListDetail
                    item={item}
                    onCancel={this.onCancel}
                    cpoID={this.props.cpoID}
                    itemID={this.props.itemID}
                    key="comp1"
                />
            </Base>
        );
    }

    onCancel = () => {
        const { cpoID, itemID } = this.props;
        this.props.cancelItem(cpoID, itemID);
    };

    onNewComment = message => {
        const { cpoID, itemID, username } = this.props;
        this.props.newComment({ cpoID, itemID, username, message });
    };
}

const mapStateToProps = (store, ownProps) => ({
    cpoID: ownProps.match.params.cpoID,
    itemID: ownProps.match.params.cpoItemID,
    username: store.auth.user.username,
    item: store.cpo.selectedCpo ? store.cpo.selectedCpo.cpo_items[ownProps.match.params.cpoItemID] : null,
    loading: store.cpo.loading
});
const mapDispatchToProps = dispatch => ({
    cancelItem: (cpoID, itemID) => dispatch(cpo.actions.cancelCpoItem(cpoID, itemID)),
    getItem: (cpoID, itemID) => dispatch(cpo.actions.getCpoItem(cpoID, itemID)),
    newComment: comment => dispatch(cpo.actions.newItemComment(comment))
});
export default connect(mapStateToProps, mapDispatchToProps)(ItemDetail);
